
export default function () {

	$(function () {
		$.validator.addMethod(
			"ValidaSelect",
			function (value, element) {

				if ($("#select-form").val() === "") {
					return false;
				} else {
					return true;
				}
			}
		);
	});

	$(".form-validate").each(function () {
		$(this).validate({
			ignore: ".ignore",
			rules: {
				name: {
					required: true,
					minlength: 3
				},
				phone: {
					required: true,
					minlength: 14
				},
				email: {
					required: true,
					email: true
				},
				check:{
					required: true,
				},
				search:{
					required: true
				},
				terms:{
					required: true
				},
				hiddenRecaptcha: {
					required: function () {
						// Retorna true se o captcha não tiver resposta
						return grecaptcha.getResponse() === "";
					}
				},
				'ValidaSelect': {
					required: true
				}
			},
			messages: {
				name: {
					required: "Por favor, informe seu nome",
					minlength: "O nome deve ter pelo menos 3 caracteres"
				},
				phone: {
					required: "Por favor, informe seu telefone",
					minlength: "O telefone deve ter DDD e número válido"
				},
				email: {
					required: "É necessário informar um e-mail",
					email: "É necessário informar um e-mail válido",
				},
				check:{
					required: "Campo obrigatório"
				},
				search: {
					required: "Campo obrigatório"
				},
				terms: {
					required: "Campo obrigatório"
				},
				hiddenRecaptcha: {
					required: "Por favor, confirme que você não é um robô."
				},
				'ValidaSelect': {
					required: "Campo obrigatório"
				}
			}
		});
	});

	function captchaCallback() {
		// Atualiza o valor do campo oculto e força a revalidação
		$("#hiddenRecaptcha").val("ok");
		$(".form-contact").validate().element("#hiddenRecaptcha");
	}
}